import controller from './controller';
import template from './template.html';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.account.myProfile', {
		url: '/myProfile',
		controllerAs: 'ctrl',
		controller: controller,
		template: template
	})


}


/** WEBPACK FOOTER **
 ** ./src/main/account/myProfile/routes.js
 **/